import {HTTP} from "@/http";

class CategoryService {
  /**
   * Get all report categories
   * @param {string} [tenantId] - Optional tenant ID for filtering categories (for superadmins)
   * @returns {Promise<Object>} Promise that resolves to the categories response
   */
  get(tenantId = null) {
    const params = tenantId ? { tenantId } : {};
    return HTTP.get('api/v2/report-categories', { params });
  }
}

/**
 *
 * @type {CategoryService}
 */
export const categoryService = new CategoryService();
